import { useQuery } from '@tanstack/vue-query'
import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { queryKeys } from '~/queryClient'
import { fetchWalletPaymentModel, isWalletDeterministicError } from '~/services-v2/financial-bff/wallet-payment-model.gql'
import { MY_WALLET_QUERY_RETRIES, MY_WALLET_QUERY_STALE_MS } from './myWalletQuery.constants'

export { isWalletForbiddenError } from '~/services-v2/financial-bff/wallet-payment-model.gql'
export type { WalletPaymentModel } from '~/services-v2/financial-bff/wallet-payment-model.gql'

interface UseWalletPaymentModelParams {
  partnerId: MaybeRefOrGetter<string | undefined>
  enabled?: MaybeRefOrGetter<boolean>
}

// The BFF only honors `partner_id` for admin (impersonate); other profiles are resolved from the token.
export default function useWalletPaymentModel(params: UseWalletPaymentModelParams) {
  const partnerId = computed(() => toValue(params.partnerId))

  const isQueryEnabled = computed(() => {
    const isEnabledByCaller = params.enabled === undefined ? true : Boolean(toValue(params.enabled))
    return isEnabledByCaller && !!partnerId.value
  })

  return useQuery({
    queryKey: computed(() => queryKeys.MY_WALLET.PAYMENT_MODEL(partnerId.value ?? '')),
    enabled: isQueryEnabled,
    queryFn: () => fetchWalletPaymentModel({ partnerId: partnerId.value }),
    staleTime: MY_WALLET_QUERY_STALE_MS,
    // Deterministic errors (forbidden, no session, not found, bad request) are not retried.
    retry: (failureCount, error) => !isWalletDeterministicError(error) && failureCount < MY_WALLET_QUERY_RETRIES,
  })
}
